import { render, staticRenderFns } from "./access.vue?vue&type=template&id=5ee4ab9c&"
import script from "./access.vue?vue&type=script&lang=js&"
export * from "./access.vue?vue&type=script&lang=js&"
import style0 from "./access.vue?vue&type=style&index=0&id=5ee4ab9c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports